export default __webpack_public_path__ + "static/media/5.d9ddc7d7.jpg";